import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { LimiteAdicionalRoutingModule } from './limite-adicional-routing.module';
import { CadastroLimiteAdicionalTranchComponent } from "./cadastro-limite/cadastro-limite-adicional-tranch/cadastro-limite-adicional-tranch.component";
import { LimiteAdicionalPesquisaComponent } from './limite-adicional-pesquisa/limite-adicional-pesquisa.component';
import { LimiteAdicionalListagemComponent } from './limite-adicional-pesquisa/limite-adicional-listagem/limite-adicional-listagem.component';
import { LimiteAdicionalPorAfComponent } from './limite-adicional-por-af/limite-adicional-por-af.component';
import { LimiteAdicionalTranchListagemComponent } from './limite-adicional-tranch-listagem/limite-adicional-tranch-listagem.component';


@NgModule({

  imports: [
    SharedModule,
    BrowserModule,
    CommonModule,
    LimiteAdicionalRoutingModule,
  ],
   declarations: [
    CadastroLimiteAdicionalTranchComponent,
    LimiteAdicionalPesquisaComponent,
    LimiteAdicionalListagemComponent,
    LimiteAdicionalTranchListagemComponent,
    LimiteAdicionalPorAfComponent
  ],
  providers:[
    DatePipe
  ]
})
export class LimiteAdicionalModule { }
